<template>
  <div class="w100 bg-w">
    <div class="w120 pt20 mc">
      <el-row :gutter="20">
        <el-col
          :style="`width: ${handleWidth(moduleData.cardCol)}`"
          v-for="item in moduleData.cardModules"
          :key="item.code"
        >
          <div class="home-card po-r">
            <div class="tx-r grey po-a cu-p" style="right: 20px"  v-if="item.code == 'TINFO_NOTICE'  || item.code == 'TINFO_POLICY_FILE' " >
              <i class="el-icon-refresh" style="padding: 0 3px;font-size: 14px" @click="iconClick(item.code)"></i>
              <span @click="goPagination(item.code)">更多</span>
            </div>

            <p class="flex-box al-c mb10 card-title" v-if="item.code == 'TINFO_NOTICE'  || item.code == 'TINFO_POLICY_FILE' ">
              <img :src="`${baseUrl}images/${item.code}.png`" alt="" />
              <span class="ml10 font-20" style="color: #024A84;">{{ item.title }}</span>
            </p>
            <template v-if="item.code === 'TINFO_POLICY_FILE'">
              <div v-for="(e, i) in policyFileList" :key="i" class="content">
                <p
                  class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
                  :class="{'notReadFlag':e.readFlag=='0'}"
                  :key="e.id"
                  v-if="i < 5"
                  @click="goHref(e, '/fileDetail')"
                >
                  <span class="flex-1 mr10 ellipsis" style="margin-right: 20%; color: #444">{{ e.title }}</span>
                  <span class="grey" >{{
                    (e.createTime.trim()).split(' ')[0]
                  }}</span>
                </p>
              </div>
              <div
                v-if="!policyFileList.length"
                class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
              >
                <span>暂无数据</span>
              </div>
            </template>

            <template v-if="item.code == 'TINFO_NOTICE'">
              <div class="content">
                <p class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item" :class="{'notReadFlag':item.readFlag=='0'}" v-for="item in noticeList" :key="item.ntiId" @click="goHref(item, '/notifyDetail')">
                  <span class="flex-1 mr10 ellipsis" style="margin-right: 20%; color: #444">{{item.name}}</span>
                  <span class="grey">{{item.createTime}}</span>
                </p>
                <div
                  v-if="!noticeList.length"
                  class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
                >
                  <span>暂无数据</span>
                </div>
              </div>
            </template>
            <!--校历-->
            <template  v-if="item.code == 'TINFO_CALENDAR'">
              <schoolDate  :itemData="item" :type="moduleData.type"></schoolDate>
            </template>
            <!--便签-->
            <template v-if="item.code == 'TINFO_LABLE'">
              <note :itemData="item" :type="moduleData.type"></note>
            </template>
            <!--日程-->
            <template v-if="item.code == 'TINFO_SCHEDULE'">
              <schedule :itemData="item"  :type="moduleData.type"></schedule>
            </template>
            <!--我的事务-->
            <template v-if="item.code == 'TINFO_AFFAIR'">
              <affair :itemData="item"></affair>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tableList, fileDownload, getNoticeList, bpmnStuAndteachStastic } from "@/api/portrayal/policy";
import { getUser } from "@/api/management/user";
import { stuAndteachStastic } from "@/api/home/home";
import schoolDate from '@/components/management/showcase/childModules/SchoolDate'
import note from '@/components/management/showcase/childModules/Note'
import schedule from '@/components/management/showcase/childModules/Schedule'
import affair from '@/components/management/showcase/childModules/affair'
import {getCardList} from '@/api/managementCenter/specialManage'
export default {
  name: "CARD",
  components: {schoolDate, note, schedule, affair},
  props: ["moduleData"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      collectList: [],
      policyFileList: [],
      noticeList: [],
        stasticList: [],
    };
  },
  computed: {},
  created() {
    // this.getPolicyFileList();
    // this.getNoticeList();
    this.getCardData('0');
  },
  mounted() {},
  destroyed() {},
  methods: {
      getCardData(type){
          let params = {
              type: type || ''
          }
          getCardList(params).then(res =>{
              if(type == '0'){
                  this.noticeList = res.data.data.records
              }
              if(type == '1'){
                  this.policyFileList = res.data.data.records
              }

          })
      },
    handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.3%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.6%";
        default:
          return "50%";
      }
    },
    clickServeItem(item) {
      switch (item.serveType) {
        case 0:
          this.$router.push({
            path: `/serveSearch/${item.id}/${item.interfaceUrl}`,
          });
          break;
        case 1:
          this.$router.push({
            path: `/serveApproval/${item.id}`,
          });
          break;
        case 2:
          this.$router.push({
            path: `/serveCustomized/${item.id}/${item.interfaceUrl}`,
          });
          break;
        case 9:
          this.$http
            .post(
              "/statistical/serverInsert",
              this.$qs.stringify({
                serviceId: item.id,
                appType: 9,
              })
            )
            .then(() => {})
            .catch(() => {});

          this.url = item.linkUrl;

          this.$nextTick(() => {
            this.$refs.url.click();
          });
          break;
        default:
          break;
      }
    },
      iconClick(val){
        val == 'TINFO_NOTICE' ? this.getCardData('0') :  this.getCardData('1')
      },
      //校内公文
    getPolicyFileList() {
      tableList({ current: 1, size: 5 }).then(({ data }) => {
        this.policyFileList = data.data.records;
      });
    },
      //通知公告
    getNoticeList(){
      getNoticeList({len:5,pos:0})
      .then(({data}) => {
        if(data.code == 0){
          this.noticeList = data.data;
        }else {
          this.$message.error(data.msg)
        }
      })
    },
    goHref(item, path){
      let routeData = this.$router.resolve({
        name: path,
        query: {
          id: item.ntiId || item.id,
            fileId:item.fileId||'',
            type:item.ntiType||''
        }
      });
      window.open(routeData.href);
    },
    goPagination(code){
      const type = code === 'TINFO_POLICY_FILE' ? 'file' :'notice'
      let routeData = this.$router.resolve({
        name:'/noticesAndFilesPagination',
        query: {
          type,
        }
      });
      window.open(routeData.href);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.home-card {
  margin: 0 0 20px 0;
  padding: 15px 20px;
  width: 100%;
  height: 233px;
  /*background: #f5f6f8;*/
  background: #fff;
}

.msg-item {
  line-height: 24px;
  text-indent: 20px;
}

.msg-item:hover {
  background: #ebebec;
}

.notReadFlag::before {
  display: block;
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c84747;
  left: 4px;
  top: calc(50% - 3px);
}

.state-box {
  display: inline-block;
  padding: 3px 9px;
  font-size: 12px;
}

.state-box-1 {
  color: #0f5892;
  background: #e3edf5;
}

.state-box-2 {
  color: #8ac5a7;
  background: #e3ede9;
}
  .notReadFlag{
    position: relative;
  }
.card-title{
  color: #024a84;
  border-bottom: 1px solid #ECECEC;
  padding-bottom: 5px;
}
.titleClass{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px #e9e9e9 solid;
  padding: 5px 0;
}
::-webkit-scrollbar {
  display: none;
}
  .stasticCla{
    height: 170px;
    overflow: auto;
  }
  .content{
    overflow: auto;
  }
</style>
